import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  tableCell: {
    padding: "0.2rem 0.5rem",
    fontSize: "13px",
    textAlign: "right",
  },
  tableCellLeft: {
    textAlign: "left",
  },
}));
